<template>
  <div class="hot-recommend">
    <!-- <div class="recommend-head">热点推荐</div> -->
    <div style="height:10px;background-color:#1b1b1b;flex-shrink:0"></div>
    <div class="container-scroll"
         id="hot-recommend-container">
      <div class="container"
           id="recommend-list">
        <div style="position:absolute;right:15px;">
          <div class="icon-calendar">
            <!-- 日历图标 -->
            <img src="../../assets/dateIcon.svg"
                 class="date-icon"
                 @click="openCalendar()" />
            <!-- 日历 -->
            <div id="calendar"></div>
          </div>
        </div>
        <div v-for="(item,index1) of listData"
             :key='index1'
             class="data-main"
             :id="index1+'dataMain'">
          <p class="date"
             v-if="item.blocks.length>0">
            <span class="clock"></span>
            <span class="add-border">日期：{{item.recommend_date.replace(/-/ig, "")}}</span>
          </p>
          <div v-for="(block,index) of item.blocks"
               class="list-box"
               :key='index'>
            <!-- 如果有多个核心观点用线隔开 -->
            <!-- <div v-if="index!==0"
                 class="split-line"></div> -->
            <p class="margin-top-line"></p>
            <table>
              <!-- 核心观点改推荐度 -->
              <tr class="list-title flexWidth">
                <span class="blue"
                      @dblclick="go2TimeLine(block.block_code)"
                      @click="emitBlockCode(block.block_code)">{{block.block_name}}</span>
                <span :class="{red:block.zf>0 , green:block.zf<0}">(
                  <span class="maxZf"
                        :ltip="formatTip(block.zf_date,block.days,block.zf)"
                        ltip-pos="right">{{getZf(block.zf)}}</span> ) &nbsp;</span>推荐度：
                <span :class="{red:block.block_tips=='积极',yellow:block.block_tips=='谨慎'}">{{block.block_tips}}</span>
                <!-- 悬浮tips -->
                <!-- <p :id="'alltip'+index1+index"
                   class="zfTip hide">
                  <span :class="{hide:block.zf_date==null}">{{getHighMonth(block.zf_date)}}月{{getHighDay(block.zf_date)}}日，</span>
                  <span>{{block.days}}个交易日累计涨幅</span>
                  <span :class="{red:block.zf>0 , green:block.zf<0}">{{getZf2(block.zf)}}</span>
                </p> -->
              </tr>
              <tr v-if='block.message_news_manual'
                  class="flexWidth">
                <span class="message-title">消息面：</span>
                <span class="message-content">
                  <span>{{block.message_news_manual}}</span>
                </span>
              </tr>
              <tr v-show="block.message_news"
                  v-else
                  class="flexWidth">
                <span class="message-title">消息面：</span>
                <span class="message-content">
                  <span>{{block.message_news}}</span>
                </span>
              </tr>
              <tr v-if="block.message_technical_manual"
                  class="flexWidth">
                <span class="message-title">技术面：</span>
                <span class="message-content">
                  <span>{{block.message_technical_manual}}</span>
                </span>
              </tr>
              <tr v-show="block.message_technical"
                  v-else
                  class="flexWidth">
                <span class="message-title">技术面：</span>
                <span class="message-content">
                  <span>{{block.message_technical}}</span>
                </span>
              </tr>
              <!-- 重点关注标题删去 -->
              <!-- <p class="list-title"
               v-if="block.stocks.length>0">[isRed,widthClass,zfClass]stock-zf
              重点关注：</p> -->
              <tr v-for="(stock,index) of block.stocks"
                  :key="index"
                  class="flexWidth stock-tr">
                <span class="stock-name-zf">
                  <span class="blue stock-name hidden-name"
                        @dblclick="go2TimeLine(stock.stock_code)"
                        @click="getBlock(stock.stock_code,stock.block_code,stocks[stock.stock_code]['zqmc'])"
                        v-if="stocks[stock.stock_code]"
                        :title="stocks[stock.stock_code]['zqmc']">{{stocks[stock.stock_code]['zqmc']}}</span>
                  <span :class="{red:stock.zf>0 , green:stock.zf<0,stockZf:true}"
                        v-if="stocks[stock.stock_code]"
                        :ltip="formatTip(stock.zf_date,stock.days,stock.zf)"
                        ltip-pos="right">{{getZf(stock.zf)}}</span>
                </span>
                <span class="stock-message"
                      v-if="stock.message_tech_manual">{{stock.message_tech_manual}}</span>
                <span class="stock-message"
                      v-else>{{stock.message_tech}}</span>
              </tr>
            </table>
            <p class="margin-top-line"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '../../api/request/request';
import { join } from 'path';
import { setTimeout } from 'timers';
import { NUM4, NUM6, NUM8 } from '../../constant';
export default {
  props: {},
  beforeCreated() {},
  created() {},
  data() {
    return {
      listData: [],
      stockCodes: [],
      stocks: [],
      page: 1,
      dates: [],
      formatDates: [],
      showDate: '', //选择的日期
      clickTo: 0,
      loadbgdate: '20180701',
      jumpDate: '',
      recommendDate: [],
      firstDay: '',
      minDay: ''
    };
  },
  // watch: {
  //   showDate(newval, oldval) {
  //     this.chooseDate(newval);
  //   }
  // },
  beforeMount() {},
  mounted() {
    this.getData();
    this.getHotDate();
    $('#hot-recommend-container').scroll(e => {
      const scrollTop = $('#hot-recommend-container').scrollTop();
      const listHeight = $('#recommend-list').height();
      if (listHeight - scrollTop < 400) {
        // console.log(this.loadbgdate);
        // console.log('97822315645+' + this.loadbgdate);
        if (this.loadbgdate > this.dates[this.dates.length - 1]) {
          this.loadbgdate = this.getNewLoadDate(this.loadbgdate);
          this.getData();
        }
      }
    });
    LTip.zIndex = 100;
    LTip.customStyle({ bg: 'rgba(33,33,33,0.8)', bg2: 'rgba(33,33,33,0.8)' });
    LTip.reBind();
  },
  methods: {
    // enter(key) {
    //   let allTips = document.getElementById(key);
    //   console.log('allTipsid' + key);
    //   allTips.style.display = 'block';
    // },
    // leave(key) {
    //   let allTips = document.getElementById(key);
    //   console.log('allTips' + key);
    //   allTips.style.display = 'none';
    // },
    formatTip(date, days, zf) {
      try {
        let colorZf =
          Number(zf) >= 0
            ? '<span class="red">' + this.getZf2(zf) + '</span>'
            : '<span class="green">' + this.getZf2(zf) + '</span>';
        if (date) {
          return (
            ' 截止' +
            date.substring(5, 7) +
            '月' +
            date.substring(8, 10) +
            '日,' +
            days +
            '个<br>交易日累计涨幅' +
            colorZf
          );
        }
      } catch (e) {
        console.warn('err');
      }
    },
    getNewLoadDate(date) {
      let newDate = '';
      let minusDay = '';
      let year = date.substring(0, 4);
      let month = date.substring(4, 6);
      let day = date.substring(6, 8);
      minusDay = Number(day) - 6;
      if (minusDay > 0) {
        newDate = year + '' + month + '' + this.getTwoDay(Number(day) - 6);
      } else {
        if (Number(month) === 1) {
          newDate = year - 1 + '' + 12 + '' + this.getTwoDay(25 + Number(day));
        } else if (Number(month) === 3) {
          if (Number(year) % 4 == 0 && (Number(year) % 100 != 0 || Number(year) % 400 == 0)) {
            newDate = year + '' + this.getTwoMonth(Number(month) - 1) + '' + this.getTwoDay(23 + Number(day));
          } else {
            newDate = year + '' + this.getTwoMonth(Number(month) - 1) + '' + this.getTwoDay(22 + Number(day));
          }
        } else if (month === 5 || month === 7 || month === 10 || month === 12) {
          newDate = year + '' + this.getTwoMonth(Number(month) - 1) + '' + this.getTwoDay(24 + Number(day));
        } else {
          newDate = year + '' + this.getTwoMonth(Number(month) - 1) + '' + this.getTwoDay(25 + Number(day));
        }
      }
      // return newDate;
      return newDate;
    },
    // 格式化日期的月
    getTwoMonth(month) {
      if (month < 10) {
        return '0' + month;
      } else {
        return month;
      }
    },
    // 格式化日期的日
    getTwoDay(day) {
      if (day < 10) {
        return '0' + day;
      } else {
        return day;
      }
    },
    // 格式化最大涨幅的显示
    getZf(code) {
      let newCode;
      if (code == '' || code == 'NUL') {
        newCode = '--';
      } else if (code > 0) {
        newCode = '+' + code + '%';
      } else if (code == 0) {
        newCode = '--';
      } else if (code < 0) {
        newCode = code + '%';
      }
      return newCode;
    },
    // 格式化最大涨幅的悬浮显示
    getZf2(code) {
      let newCode;
      if (code == '' || code == 'NUL') {
        newCode = '--';
      } else if (code > 0) {
        newCode = code + '%';
      } else if (code == 0) {
        newCode = 0;
      } else if (code < 0) {
        newCode = code + '%';
      }
      return newCode;
    },

    // 打开日历组件函数
    openCalendar() {
      WdatePicker({
        el: 'calendar',
        skin: 'blackbyjsc',
        readOnly: false,
        isShowClear: false,
        isShowToday: false, //今天
        isShowOK: false, //确定
        // qsEnabled: false,
        dateFmt: 'yyyyMMdd',
        opposite: true,
        disabledDates: this.formatDates,
        minDate: this.minDay, //有数据的起始日期
        // maxDate: '%y-%M-%d',
        maxDate: this.firstDay, //有数据的最近日期
        disabledDays: [0, 6],
        startDate: this.firstDay,
        onpicking: dp => {
          return false;
        },
        onpicked: dp => {
          this.showDate = dp.cal.getNewDateStr();
          this.loadbgdate = this.showDate;
          this.jumpDate = this.showDate;
          this.loadbgdate = this.getNewLoadDate(this.loadbgdate);
          this.getData();
          let self = this;
          setTimeout(function() {
            self.topDate(self.jumpDate);
          }, 500);
        }
      });
    },
    //滚动条滚动
    topDate(date) {
      let indexDate = '';
      let key = '';
      indexDate = this.dates.indexOf(date);
      key = indexDate + 'dataMain';
      let allTips = document.getElementById(key);
      const ele = document.querySelector('.container-scroll');
      ele.scrollTop = allTips.offsetTop - 38;
      // console.log(scrollTop);
    },
    //获取有热点推荐内容的日期
    getHotDate() {
      try {
        this.$http.get(`//gpc.${window.dynamicDomain}/idea/hots/hot/getdates`, { withCredentials: true }).then(res => {
          if (res.data.errorcode === 0) {
            const result = res.data.result;
            for (let day of result) {
              this.dates.push(day.split('-').join(''));
            }
            // 将有热点推荐的日期传入formatDates
            for (let val of this.dates) {
              this.formatDates.push(val.substring(0, 4) + '-' + val.substring(4, 6) + '-' + val.substring(6, 8));
            }
            if (Array.isArray(this.dates) && this.dates.length > 0) {
              //有数据的起始日期
              const lastDate = this.dates[this.dates.length - 1];
              this.minDay = `${lastDate.substring(0, NUM4)}-${lastDate.substring(NUM4, NUM6)}-${lastDate.substring(NUM6, NUM8)}`;
            }
          }
        });
      } catch (e) {}
    },

    getData() {
      this.$http
        .get(`//gpc.${window.dynamicDomain}/idea/hots/hot/getrecommend`, {
          params: {
            bgdate: this.loadbgdate
          },
          withCredentials: true
        })
        .then(res => {
          if (res.data.errorcode === 0) {
            const result = res.data.result;
            for (let item of result) {
              if (this.recommendDate.indexOf(item.recommend_date) < 0 && item.blocks.length) {
                this.listData.push(item);
                this.recommendDate.push(item.recommend_date);
              }
              for (let block of item.blocks) {
                for (let stock of block.stocks) {
                  this.stockCodes.push(stock.stock_code);
                }
              }
            }
            this.firstDay = this.listData[0].recommend_date;
            Acme.getHqData(
              {
                code: this.stockCodes,
                type: ['zqmc', 'new'],
                period: 'now',
                mode: 'after'
              },
              data => {
                this.stocks = data;
                this.$nextTick(() => {
                  LTip.reBind();
                });
              },
              error => {
                console.log(error);
              }
            );
          }
        });
    },

    go2TimeLine(code) {
      Acme.go2TimeLine(code);
    },
    // 鼠标单击个股名称触发事件
    getBlock(stockCode, blockCode, stockname) {
      this.emitBlockCode(blockCode);

      if (window.clientType === 2) {
        this.$store.dispatch({
          type: 'setActiveChooseStock',
          activeChooseStock: {
            stockName: stockname,
            stockCode: stockCode,
            active: 1
          }
        });
      }
    },

    emitBlockCode(code) {
      this.$store.commit('setHotRecommendClick', true);
      eventBus.$emit('blockCode', code);
      this.$store.dispatch({
        type: 'setActiveBlock',
        blockCode: code
      });
    }
  }
};
</script>
<style scoped>
.hot-recommend {
  background-color: #1b1b1b;
  display: flex;
  flex-direction: column;
}
.container-scroll {
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
}
p {
  margin: 0;
}
.container {
  color: #a0a0a0;
  font-size: 12px;
  text-align: left;
  line-height: 24px;
  margin: 0;
  padding: 0;
}
.clock {
  background-image: url(../../assets/clock.svg);
  background-repeat: no-repeat;
  background-position: center center;
  display: inline-block;
  height: 12px;
  width: 12px;
}
.add-border {
  border: 1px solid #282828;
  padding: 0 5px;
}
.date {
  line-height: 12px;
  margin-left: 5px;
}
.list-box {
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid gray;
  padding-right: 5px;
  /* width: 280px; */
}
.list-title {
  font-size: 14px;
  line-height: 28px;
  color: white;
  /* text-align: center; */
  justify-content: center;
  border: 1px solid #282828;
  position: relative;
}
.margin-top-line {
  display: block;
  height: 10px;
}
.blue {
  color: #4297d5;
  cursor: default;
}
.red {
  color: red;
}
.yellow {
  color: #d59600;
}
.green {
  color: #1cbf7b;
}
.white {
  color: white;
}
.point {
  font-size: 14px;
  font-weight: bold;
}
.split-line {
  height: 1px;
  border-top: 1px solid #282828;
  box-sizing: border-box;
}

.icon-calendar {
  position: relative;
}
.date-icon {
  position: absolute;
  top: 0;
  right: -2px;
  display: inline-block;
  height: 15px;
  width: 15px;
  background-color: #1b1b1b;
  /* background: url('../../assets/dateIcon.svg'); */
  z-index: 9999;
  cursor: pointer;
}
/* 表格样式 */
table {
  width: 100%;
  border-collapse: collapse;
}
tr {
  /* width: 100%; */
  border: 1px solid #282828;
  border-top: 0;
}
.flexWidth {
  width: 100%;
  display: flex;
}
.stock-tr {
  height: 20px;
}
.message-title {
  width: 53px;
  padding: 0 0 0 5px;
  line-height: 18px;
}
.message-content {
  flex: 1;
  line-height: 18px;

  /* max-width: 230px; */
}
.message-content span {
  word-break: break-word;
}
.stock-name-zf {
  width: 120px;
  padding: 0 0 0 5px;
  border-right: 1px solid #282828;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.stockZf {
  padding: 0 5px 0 10px;
  position: relative;
}
.stock-message {
  flex: 1;
  line-height: 20px;
  text-align: center;
  word-break: break-word;
}
#calendar {
  width: 0px;
  visibility: hidden;
  position: absolute;
  top: 200px;
  right: 183px;
  z-index: 9999;
}
.hide {
  display: none;
}
.zfTip {
  background-color: #1b1b1b;
  position: absolute;
  padding: 2px 5px;
  top: 25px;
  left: 10px;
  z-index: 10000;
  color: #fff;
}
.maxZf {
  cursor: pointer;
  position: relative;
}

.hidden-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/blockmaps/hotRecommend.vue